import { useMemo } from 'react';

import { useAddOnsManager } from '@/ducks/addOns/hooks';
import useFlowType from '@/features/flowType/useFlowType';
import { useAppSelector } from '@/store';

import { selectCalcMainValues } from './calcMainValuesSelector';

const useCalcMainValues = ({
  isPayInFullPromoAppliedWhenAvailable = false,
}: {
  isPayInFullPromoAppliedWhenAvailable?: boolean; // handle the case when user is on payment+ page (temporary)
} = {}) => {
  const { isMNVV } = useFlowType();
  const { isAddedByCode, loaded: isAddOnsLoaded } = useAddOnsManager();

  const selectorParams = useMemo(
    () => ({
      isAddOnAddedByCode: isAddedByCode,
      isAddOnsLoaded,
      isMNVV,
      isPayInFullPromoAppliedWhenAvailable,
    }),
    [isAddedByCode, isAddOnsLoaded, isMNVV, isPayInFullPromoAppliedWhenAvailable],
  );

  return useAppSelector((state) => selectCalcMainValues(state, selectorParams));
};

export default useCalcMainValues;
